export interface OfflineFlightBadgeProps {
  isCached: boolean;
  sizeMb?: number;
  cachedAt?: string;
}

export function OfflineFlightBadge(
  { isCached, sizeMb, cachedAt }: OfflineFlightBadgeProps,
): JSX.Element | null {
  if (!isCached) return null;
  const title =
    sizeMb !== undefined && cachedAt !== undefined
      ? `Available offline — ${Math.round(sizeMb)} MB, cached ${new Date(cachedAt).toLocaleDateString()}`
      : "Available offline";
  return (
    <span className="vmc-offline-badge" aria-label={title} title={title}>
      &#9729;&#65038; &#10003;
    </span>
  );
}
